import React from "react";

export const ContractorUserDetailContext = React.createContext(null);

export const useContractorUserDetailContext = () =>{
    const context = React.useContext(ContractorUserDetailContext);

    if(!context) throw new Error("Contractor User Details Context Not Provided");

    return context
};